import { useQuery, QueryKey } from '@tanstack/react-query';
import { useAuth0 } from '../auth/useAuth0';

/**
 * Thin wrapper over useQuery for our token-authenticated GraphQL calls: it
 * fetches the Auth0 token inside the queryFn and hands it to the service fn.
 * Combined with the app QueryClient defaults this gives every screen
 * cache-first loads (instant on revisit) with background revalidation.
 *
 * Pass `enabled: false` (via opts) until the businessId/ids are ready.
 */
export function useAuthedQuery<T>(
    queryKey: QueryKey,
    fetcher: (token: string) => Promise<T>,
    opts?: { enabled?: boolean; staleTime?: number; gcTime?: number },
) {
    const { getAccessTokenSilently } = useAuth0();
    return useQuery<T>({
        queryKey,
        queryFn: async () => fetcher(await getAccessTokenSilently()),
        ...opts,
    });
}
